var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSetCustomer = function SvgSetCustomer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.47851 10.4589C5.6596 11.5189 6.31368 12.0902 6.98224 12.0914C7.65081 12.0902 8.30488 11.5189 8.48598 10.4589C8.66725 9.39784 8.15508 8.5 6.98428 8.5C5.81347 8.5 5.29723 9.39784 5.47851 10.4589Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02093 14.8655C4.03967 14.7645 4.06194 14.6645 4.08842 14.5695C4.19625 14.1827 5.38223 13.314 6.20683 12.7484C6.68963 12.4172 7.31037 12.4172 7.79317 12.7484C8.61777 13.314 9.80375 14.1827 9.91158 14.5695C9.93806 14.6645 9.96033 14.7645 9.97907 14.8655C10.1003 15.5192 9.6821 16.1214 9.0581 16.2631C8.51735 16.3859 7.79976 16.5 7 16.5C6.20024 16.5 5.48265 16.3859 4.9419 16.2631C4.3179 16.1214 3.89971 15.5192 4.02093 14.8655Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7C0 5.89543 0.895431 5 2 5H26C27.1046 5 28 5.89543 28 7V13.275C27.9553 13.2283 27.9099 13.182 27.864 13.136C24.3492 9.62132 18.6508 9.62132 15.136 13.136C13.3158 14.9563 12.4382 17.3622 12.5034 19.7472C12.5011 19.8303 12.5 19.9145 12.5 20H2C0.895431 20 0 19.1046 0 18V7ZM2 8C2 7.44772 2.44772 7 3 7H11C11.5523 7 12 7.44772 12 8V17C12 17.5523 11.5523 18 11 18H3C2.44772 18 2 17.5523 2 17V8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5942 25.9155C22.6757 27.775 18.7582 27.4304 16.21 24.8819C13.2633 21.935 13.2633 17.1571 16.21 14.2102C19.1566 11.2633 23.934 11.2633 26.8806 14.2102C29.4289 16.7588 29.7734 20.6768 27.914 23.5956L31.5197 27.2017C32.1603 27.8423 32.1603 28.881 31.5197 29.5216C30.8791 30.1623 29.8406 30.1623 29.2 29.5216L25.5942 25.9155ZM25.0052 23.0455C25.0116 23.0389 25.018 23.0323 25.0245 23.0258C25.0311 23.0193 25.0376 23.0128 25.0443 23.0064C26.9465 21.083 26.94 17.9815 25.0248 16.0661C23.1031 14.1442 19.9874 14.1442 18.0657 16.0661C16.144 17.988 16.144 21.1041 18.0657 23.026C19.9809 24.9413 23.0819 24.9478 25.0052 23.0455Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "currentColor"
  })))));
};
export default SvgSetCustomer;